import {AppBar} from "@/keys";
import {ref, watchEffect} from "vue";
import {useCurrentWindowScroll} from "@/composables/window";

export const useAppbarConfig = () => {
    const {isTopOfDocument} = useCurrentWindowScroll();
    const fontSize = ref(AppBar.TEXT_SIZE);
    const height = ref(AppBar.HEIGHT_TOP);

    const updateFontSize = () => {
        if (isTopOfDocument.value) {
            fontSize.value = AppBar.TEXT_SIZE;
        } else {
            fontSize.value = AppBar.TEXT_SIZE_SCROLLING;
        }
    }

    const updateHeight = () => {
        if (isTopOfDocument.value) {
            height.value = AppBar.HEIGHT_TOP;
        } else {
            height.value = AppBar.HEIGHT_SCROLLING;
        }
    }

    watchEffect(updateFontSize);
    watchEffect(updateHeight);

    return {
        fontSize,
        height,
        isFlat: isTopOfDocument,
        isTopOfDocument,
    }
}
